export const FuelCapStatus = {
    Open: 1,
    Close: 2,
    Tampering: 3,
}